import { render } from "./ButtonGroup.vue?vue&type=template&id=82526034"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/button-group/ButtonGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82526034"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82526034', __exports__)) {
    api.reload('82526034', __exports__)
  }
  
  module.hot.accept("./ButtonGroup.vue?vue&type=template&id=82526034", () => {
    api.rerender('82526034', render)
  })

}


export default __exports__